// 全画面で適用する CSS
// 各 *.vue ファイルの CSS よりも先に読み込まれて欲しいので、何よりも先に import する。
import './styles/chamomile-style.scss'
import 'element-ui/lib/theme-chalk/index.css'
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import fileSize from 'filesize'
import Vue from 'vue'
import Vuex from 'vuex'
import router from './router'
import ChamomileApp from './ChamomileApp.vue'
import RootStore from './store'
import attachmentUrl from './filters/attachment-url'
import publishStatus from './filters/publish-status'
import formatDate from './filters/format-date'

import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/ja'

import VFoundation from './directives/foundation'
import VEscapeKey from './directives/escape-key'
import VClickDocument from './directives/click-document'

Vue.config.productionTip = false

Vue.use(Vuex)

Vue.directive('foundation', VFoundation)
Vue.directive('escape-key', VEscapeKey)
Vue.directive('click-document', VClickDocument)

const elementUiLocale = Object.assign({}, locale)
elementUiLocale.el.datepicker.confirm = '選択'
Vue.use(ElementUI, { locale: elementUiLocale })

// グローバール空間のフィルタ
Vue.filter('attachmentUrl', attachmentUrl)
Vue.filter('publishStatus', publishStatus)
Vue.filter('fileSize', fileSize)
Vue.filter('formatDate', formatDate)

const store = new Vuex.Store(RootStore)

/* eslint-disable no-new */
new Vue({
  el: '#chamomileApp',
  router,
  store,
  template: '<ChamomileApp/>',
  components: { ChamomileApp }
})
